/* ============================================================
   VEYLA | PDP behaviour
   Port note: forked from the Derma Muse PDP (dm-* pack). Every add-to-cart
   does its own POST /cart/add.js. Nothing here clicks another widget's button
   or calls another widget's open-cart function.

   Single-variant product, so there is no shade module. The zone picker is
   cosmetic: it aims the copy and the cart label, it never changes the variant.
   ============================================================ */
(() => {
  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  /* ---------- the offer ----------
     Every price, the Seal plan, the zones and the subscribe default now live in
     shared/vy-offer.js, because the homepage sells the same ladder and the two
     must not drift. That file is the only place to edit a number, and it loads
     before this one. Nothing else about this page changed: the names below are
     the same names the rest of this file has always used. */
  const O = window.VY_OFFER;
  const { SERUM, SUB, TIERS, ZONES, money, planFor, subCents } = O;
  const state = { zone: O.ZONE_DEFAULT, tier: O.TIER_DEFAULT, sub: O.SUB_DEFAULT };

  /* Local shim: this file passes tier OBJECTS around, the module takes keys.
     Kept so the refactor touches no other line of this page. */
  const tierKeyOf = t => Object.keys(TIERS).find(k => TIERS[k] === t);
  const tierTotal = t => O.tierTotal(tierKeyOf(t), state.sub);

  /* ---------- header menu (mobile) ---------- */
  const burger = $('#vy-burger');
  const nav    = $('#vy-nav');
  if (burger && nav) {
    burger.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', String(open));
    });
  }

  /* ---------- gallery ---------- */
  const stage = $('#vy-stage-img');
  const thumbRail  = $('#vy-thumbs-rail');
  const thumbTrack = $('#vy-thumbs');

  /* The thumbs live on one scrolling row, so a thumb picked with the keyboard
     from the far end has to pull itself into view rather than sit half cut off. */
  const showThumb = btn => {
    // scrollTo is missing in some non-browser DOMs, and this must never be the
    // reason a click stops halfway through updating the stage
    if (!thumbTrack || !btn || !thumbTrack.scrollTo) return;
    const left = btn.offsetLeft - (thumbTrack.clientWidth - btn.offsetWidth) / 2;
    thumbTrack.scrollTo({ left: Math.max(0, left), behavior: calmMotion ? 'auto' : 'smooth' });
  };

  const thumbs = $$('.vy-thumbs button');
  const count  = $('#vy-stage-count');
  const stageBadge = $('.vy-stage-badge');

  /* One selector for every route in: a thumb click, an arrow, a keyboard arrow.
     The thumbs are hidden on mobile for now, so the arrows are the only way
     through the gallery there and cannot be a second, separate code path. */
  const pickShot = (i, scroll) => {
    if (!thumbs.length) return;
    const n = (i + thumbs.length) % thumbs.length;          // wraps both ways
    const btn = thumbs[n];
    thumbs.forEach(b => b.setAttribute('aria-current', 'false'));
    btn.setAttribute('aria-current', 'true');
    stage.src = btn.dataset.full;
    stage.alt = btn.dataset.alt || '';
    if (count) count.textContent = `${n + 1} / ${thumbs.length}`;
    // the badge belongs to the hero shot only; on any other slide it would
    // sit on top of before/afters and review collages
    /* task: veyla-port/9. The badge used to show on slide 1 only, back when
       slide 1 was a plain product render. Purrity's own slides carry baked-in
       headlines and a BEST SELLER tag, so the pill landed on top of them.
       It now shows only on slides that declare they have no baked text. */
    /* The badge belongs to the hero shot ONLY: on any other slide it would sit
       on top of a before/after or a review collage. Purrity's own slides carry
       baked-in headlines and a BEST SELLER tag, so it is also suppressed when
       the hero itself already says something. Both conditions, not either. */
    if (stageBadge) stageBadge.classList.toggle('is-off', n !== 0 || btn.dataset.baked === 'true');
    if (scroll) showThumb(btn);
  };
  const currentShot = () => Math.max(0, thumbs.findIndex(b => b.getAttribute('aria-current') === 'true'));

  thumbs.forEach((btn, i) => btn.addEventListener('click', () => pickShot(i, true)));
  const prevShot = $('#vy-stage-prev');
  const nextShot = $('#vy-stage-next');
  if (prevShot) prevShot.addEventListener('click', () => pickShot(currentShot() - 1, true));
  if (nextShot) nextShot.addEventListener('click', () => pickShot(currentShot() + 1, true));
  if (count) count.textContent = `1 / ${thumbs.length}`;

  /* task: veyla-port/9. Paint the initial slide's state on load. pickShot ran
     only on interaction, so whatever the badge's markup happened to say stood
     until the first click: with slide 1 now carrying its own baked headline,
     that meant the pill sat on top of it until the visitor touched something. */
  if (thumbs.length) pickShot(currentShot(), false);

  if (thumbRail && thumbTrack) {
    const syncThumbs = () => {
      const max = thumbTrack.scrollWidth - thumbTrack.clientWidth;
      const x = thumbTrack.scrollLeft;
      thumbRail.dataset.atStart = String(x <= 2);
      thumbRail.dataset.atEnd = String(x >= max - 2 || max <= 0);
    };
    thumbTrack.addEventListener('scroll', syncThumbs, { passive: true });
    window.addEventListener('resize', syncThumbs);
    syncThumbs();
    // thumbnails settle after layout and change scrollWidth, so check again
    window.addEventListener('load', syncThumbs);
  }

  /* ---------- actives strip under the stage ---------- */
  const actives = $('#vy-actives');
  if (actives) {
    const bar = $('.vy-actives-bar', actives);
    const panel = $('#vy-actives-panel');
    bar.addEventListener('click', () => {
      const open = panel.hidden;
      panel.hidden = !open;
      actives.dataset.open = String(open);
      bar.setAttribute('aria-expanded', String(open));
    });
  }

  /* ---------- thinning zone picker ---------- */
  function pickZone(key) {
    state.zone = key;
    $$('.vy-zonebtn').forEach(el => el.setAttribute('aria-checked', String(el.dataset.zone === key)));
    const picked = $('#vy-zone-picked');
    if (picked) picked.textContent = ZONES[key].label;
    const note = $('#vy-zone-note');
    if (note) note.textContent = ZONES[key].note;
    render();
  }
  $$('.vy-zonebtn').forEach(el => {
    el.addEventListener('click', () => pickZone(el.dataset.zone));
    el.addEventListener('keydown', e => {
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); pickZone(el.dataset.zone); }
    });
  });

  /* ---------- proof popup ---------- */
  const vmodal = $('#vy-vmodal');
  const vthumb = $('#vy-vthumb');
  if (vmodal && vthumb) {
    const openProof = () => {
      vmodal.hidden = false;
      document.body.classList.add('vy-noscroll');
      $('.vy-vmodal-x', vmodal).focus();
    };
    const closeProof = () => {
      vmodal.hidden = true;
      document.body.classList.remove('vy-noscroll');
      vthumb.focus();
    };
    vthumb.addEventListener('click', openProof);
    $$('[data-close]', vmodal).forEach(el => el.addEventListener('click', closeProof));
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !vmodal.hidden) closeProof();
    });
    // adding to cart from inside the popup closes it, the drawer takes over
    $('.vy-vmodal-copy .vy-atc').addEventListener('click', () => setTimeout(closeProof, 900));
  }

  /* ---------- ugc reels viewer ----------
     Six 9:16 UGC videos off their live PDP, vertical snap scroll. Videos get
     their src only on first open, so the page never downloads a byte of video
     for someone who never taps the strip. */
  const reels = $('#vy-reels');
  const ugcThumbs = $$('.vy-ugc-th');
  if (reels && ugcThumbs.length) {
    const rStage = $('#vy-reels-stage');
    const rVids = $$('.vy-reel video', reels);
    const rPips = $$('#vy-reels-pips i');
    const muteBtn = $('#vy-reels-mute');
    let rMuted = true, rWired = false;
    const rMark = i => rPips.forEach((p, k) => p.classList.toggle('is-on', k === i));
    const syncMute = () => {
      muteBtn.dataset.on = String(!rMuted);
      muteBtn.setAttribute('aria-label', rMuted ? 'Unmute' : 'Mute');
      rVids.forEach(v => { v.muted = rMuted; });
    };
    const playAt = i => {
      rVids.forEach((v, k) => {
        if (k === i) {
          v.muted = rMuted;
          const p = v.play && v.play();
          // an unmuted autoplay a browser refuses falls back to muted
          if (p && p.catch) p.catch(() => { rMuted = true; syncMute(); const q = v.play && v.play(); if (q && q.catch) q.catch(() => {}); });
        } else if (v.pause) v.pause();
      });
      rMark(i);
    };
    const rWire = () => {
      if (rWired) return;
      rWired = true;
      rVids.forEach(v => { v.src = v.dataset.src; });
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(es => es.forEach(e => {
          if (e.isIntersecting && e.intersectionRatio >= .6) playAt(rVids.indexOf(e.target));
        }), { root: rStage, threshold: [0, .6] });
        rVids.forEach(v => io.observe(v));
      } else {
        // same behaviour off the scroll position when the observer is missing
        let t = null;
        rStage.addEventListener('scroll', () => {
          clearTimeout(t);
          t = setTimeout(() => playAt(Math.round(rStage.scrollTop / Math.max(1, rStage.clientHeight))), 120);
        }, { passive: true });
      }
    };
    let lastThumb = null;
    const openReels = i => {
      reels.classList.add('is-open');
      document.body.classList.add('vy-noscroll');
      rWire();
      // land on the tapped video before the first paint, no scroll animation
      rStage.scrollTop = i * rStage.clientHeight;
      playAt(i);
      $('#vy-reels-x').focus();
    };
    const closeReels = () => {
      rVids.forEach(v => { if (v.pause) v.pause(); });
      reels.classList.remove('is-open');
      document.body.classList.remove('vy-noscroll');
      (lastThumb || ugcThumbs[0]).focus();
    };
    ugcThumbs.forEach((b, i) => b.addEventListener('click', () => { lastThumb = b; openReels(i); }));
    $('#vy-reels-x').addEventListener('click', closeReels);
    reels.addEventListener('click', e => { if (e.target === reels) closeReels(); });
    muteBtn.addEventListener('click', () => { rMuted = !rMuted; syncMute(); });
    $('#vy-reels-prev').addEventListener('click', () => rStage.scrollBy({ top: -rStage.clientHeight, behavior: 'smooth' }));
    $('#vy-reels-next').addEventListener('click', () => rStage.scrollBy({ top: rStage.clientHeight, behavior: 'smooth' }));
    document.addEventListener('keydown', e => {
      if (!reels.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeReels();
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') $('#vy-reels-next').click();
      if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') $('#vy-reels-prev').click();
    });
    // adding from the pinned card closes the viewer, the drawer takes over
    $('.vy-reels-card .vy-atc', reels).addEventListener('click', () => setTimeout(closeReels, 400));
  }

  /* ---------- guarantee popup ---------- */
  const hmodal = $('#vy-hmodal');
  const hbtn = $('#vy-g-how');
  if (hmodal && hbtn) {
    const openHow = () => {
      hmodal.hidden = false;
      document.body.classList.add('vy-noscroll');
      $('.vy-hmodal-x', hmodal).focus();
    };
    const closeHow = () => {
      hmodal.hidden = true;
      document.body.classList.remove('vy-noscroll');
      hbtn.focus();
    };
    hbtn.addEventListener('click', openHow);
    $$('[data-hclose]', hmodal).forEach(el => el.addEventListener('click', closeHow));
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !hmodal.hidden) closeHow();
    });
    $('.vy-hmodal-foot .vy-atc').addEventListener('click', () => setTimeout(closeHow, 900));
  }

  /* ---------- subscribe switch ---------- */
  const subBox = $('#vy-sub');
  const subSwitch = $('#vy-sub-switch');
  if (subSwitch) subSwitch.addEventListener('click', () => { state.sub = !state.sub; render(); });

  /* ---------- surface skin ----------
     The markup ships the lab surface's card text, and this block makes the
     offer module the owner of it: titles, sublines and flags come off TIERS,
     so the same three cards sell whichever ladder vy-offer.js picked for this
     URL. On the lab surface the strings are byte-identical to the markup, so
     nothing moves.

     inline display, not [hidden]: the subscribe box is display:flex in CSS,
     which outranks the [hidden] UA rule (same trap as the HYT build). */
  if (O.SUB_ENABLED === false) {
    state.sub = false;
    if (subBox) subBox.style.display = 'none';
  }
  $$('.vy-tier').forEach(el => {
    const cfg = TIERS[el.dataset.tier];
    if (!cfg) return;
    const title = el.querySelector('b');
    if (title && cfg.cardTitle) title.textContent = cfg.cardTitle;
    const sub = el.querySelector('.vy-tier-sub');
    if (sub && cfg.cardSub) sub.textContent = cfg.cardSub;
    const flag = el.querySelector('.vy-flag');
    if (flag) { cfg.flag ? flag.textContent = cfg.flag : flag.remove(); }
  });
  /* the comparison table's per-tube claim, and the in-page links to the
     product itself: both follow the surface, so the copy page never quotes
     the other ladder's price or walks her back to the real PDP mid-pitch */
  const costClaim = $('#vy-cost-claim');
  if (costClaim && O.COST_CLAIM) costClaim.textContent = O.COST_CLAIM;
  if (O.PRODUCT_URL && O.PRODUCT_URL !== '/products/growth-serum') {
    $$('a[href="/products/growth-serum"]').forEach(a => { a.href = O.PRODUCT_URL; });
  }

  /* ---------- tier cards ---------- */
  function pickTier(key) {
    state.tier = key;
    $$('.vy-tier').forEach(el => el.setAttribute('aria-checked', String(el.dataset.tier === key)));
    render();
  }
  $$('.vy-tier').forEach(el => {
    el.addEventListener('click', () => pickTier(el.dataset.tier));
    el.addEventListener('keydown', e => {
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); pickTier(el.dataset.tier); }
    });
  });

  /* ---------- render price into CTA, sticky and banner ---------- */
  function render() {
    const t = TIERS[state.tier];
    const total = tierTotal(t);                       // tubes only, this is what recurs
    const dueNow = total;                             // what the button charges today

    /* subscribe switch: price on every tier card follows the mode */
    if (subBox) {
      subBox.dataset.on = String(state.sub);
      subSwitch.setAttribute('aria-checked', String(state.sub));
      /* The pill follows the switch again. It read "20% off locked in" in both
         modes while Kaching was pricing the cart and the discount really did
         survive the toggle. Under Seal alone the discount IS the subscription,
         so saying it is locked in with the switch off would be a promise the
         checkout does not keep. */
      const save = $('#vy-sub-save');
      if (save) save.textContent = state.sub ? '20% off applied' : 'Subscribe and save 20%';
      const terms = $('#vy-sub-terms');
      if (terms) {
        terms.hidden = !state.sub;
        // the offer module owns the sentence, and names an amount only while
        // SUB_TERMS_PRICE says the renewal amount is actually known (#855)
        terms.textContent = O.subTerms(state.tier, state.sub);
      }
    }
    $$('.vy-tier').forEach(el => {
      const cfg = TIERS[el.dataset.tier];
      if (!cfg) return;
      const em = el.querySelector('.vy-price em');
      const s  = el.querySelector('.vy-price s');
      const sv = el.querySelector('.vy-save');
      if (em) em.textContent = money(tierTotal(cfg));
      // the anchor is always the RRP, whichever mode the switch is in: it is
      // what the tubes cost bought singly, not the other side of the toggle
      if (s) s.textContent = money(cfg.compareCents);
      /* Delivery frequency, per card, only while she is subscribing. The
         tiers are on different Seal plans, so this is a real difference
         between the bars and she should not have to select each one to
         discover it. Rendered here rather than at init because it depends on
         the switch. */
      const ship = el.querySelector('.vy-tier-ship');
      if (ship) {
        ship.hidden = !state.sub;
        if (state.sub) ship.textContent = O.shipEvery(el.dataset.tier);
      }
      if (sv) sv.textContent = `You save ${money(cfg.compareCents - tierTotal(cfg))}`;
    });

    /* When the top of the ladder is not actually cheaper per tube, say so out
       loud rather than letting her work it out with a calculator. Both the
       test and the sentence come from the offer module: the sentence used to
       be typed into the markup and spent four days quoting a ladder that had
       been repriced out from under it. */
    const honest = $('#vy-tier-honest');
    if (honest) {
      const show = state.tier === O.TOP_TIER && O.topIsWorseValue(state.sub);
      honest.hidden = !show;
      if (show) honest.textContent = O.topValueNote(state.sub);
    }

    const label = `Add to cart • ${money(dueNow)}`;
    // the banner carries its own price column, so its button stays short
    $$('.vy-atc').forEach(b => { b.textContent = b.hasAttribute('data-compact') ? 'Add to cart' : label; });
    const per = $('#vy-per-tube');
    if (per) per.textContent = `${money(Math.round(total / t.tubes))} per tube`;

    const zone = ZONES[state.zone];
    const config = `${zone.label} • ${t.tubes} tubes${state.sub ? ' • Subscription' : ''}`;

    const sk = $('#vy-sticky-sub');
    if (sk) sk.textContent = config;

    /* sticky header banner: same numbers as the bottom bar, anchored on the RRP */
    const tbNow = $('#vy-tb-now');
    if (tbNow) {
      const wasCents = t.compareCents;
      tbNow.textContent = money(dueNow);
      $('#vy-tb-was').textContent = money(wasCents);
      $('#vy-tb-sub').textContent = config;
      $('#vy-tb-dot').style.background = zone.dot;
    }
  }

  /* ---------- add to cart ----------
     One writer. The buybox hands the payload to VYDrawer.add(), which posts to
     /cart/add.js on a real storefront and keeps it in memory on the prototype.
     Nothing here clicks another widget's button or borrows anyone's openCart. */
  async function addToCart() {
    /* product.serum.json (2026-08-27): the buybox there is sections/sw-buybox.liquid
       and sw-pdp.js owns the cart write. The old ladder in vy-offer.js carries
       Veyla-era selling plans this store does not have, so every secondary
       .vy-atc (reels card, how-it-works modal) presses the REAL add-to-cart
       instead of posting its own line. Absent on the default product.liquid
       route, where the old buybox is still on the page. */
    const swAtc = document.querySelector('[data-sw-atc]');
    if (swAtc) { swAtc.scrollIntoView({ block: 'center', behavior: 'smooth' }); swAtc.click(); return; }
    const btns = $$('.vy-atc');
    const labels = btns.map(b => b.textContent);
    btns.forEach(b => { b.disabled = true; });
    try {
      /* The payload is built in shared/vy-offer.js, so this page and the
         homepage post the identical line: the tier's own variant, quantity
         one, same _zone property, same selling plan.

         Built INSIDE the try on purpose. addPayload throws while the bundle
         variants are missing from the product, and that throw has to land in
         the same handler as a failed POST: buttons re-enabled, error shown,
         nothing added. Built outside, it was an uncaught exception that left
         every add-to-cart button on the page disabled with no message. */
      const items = O.addPayload(state);
      /* The upsell asks its one question here, AFTER the payload is built and
         BEFORE anything reaches the cart: a broken ladder never gets as far as
         offering an add-on, and a shopper who closes the question is never left
         with half an order. It resolves to the extra lines she agreed to, or to
         an empty list, so the serum add below is identical either way. */
      const extra = window.VYUpsell ? await window.VYUpsell.ask() : [];
      if (window.VYDrawer) await window.VYDrawer.add(items.concat(extra));
    } catch (err) {
      console.error('[vy-pdp]', err);
      btns.forEach(b => { b.textContent = 'Something went wrong, try again'; });
      setTimeout(() => btns.forEach((b, i) => { b.textContent = labels[i]; }), 2200);
    } finally {
      btns.forEach(b => { b.disabled = false; });
    }
  }
  $$('.vy-atc').forEach(b => b.addEventListener('click', addToCart));

  /* ---------- before / after sliders ----------
     Six independent pairs, all on screen. Reveal is driven by clip-path rather
     than a width change, which keeps the two photos pixel aligned. */
  const calmMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  $$('.vy-ba-stage[data-ba]').forEach((stageEl, idx) => {
    const clip   = $('.vy-ba-after', stageEl);
    const handle = $('.vy-ba-handle', stageEl);
    const range  = $('.vy-ba-range', stageEl);
    let dragging = false, touched = false;

    function setPos(pct) {
      const p = Math.min(100, Math.max(0, pct));
      clip.style.clipPath = `inset(0 ${100 - p}% 0 0)`;
      handle.style.left = p + '%';
      range.value = p;
    }
    const posFromEvent = e => {
      const r = stageEl.getBoundingClientRect();
      return ((e.clientX - r.left) / r.width) * 100;
    };

    /* The pairs sit on a horizontal scroller, so a finger dragging across a card
       has to mean "scroll the rail", not "move the slider". A mouse keeps the
       click-anywhere behaviour; touch has to start on the handle. */
    const grab = e => {
      if (e.pointerType !== 'mouse' && !e.target.closest('.vy-ba-handle')) return;
      dragging = true; touched = true;
      if (e.pointerType !== 'mouse') e.preventDefault();
      stageEl.setPointerCapture(e.pointerId);
      setPos(posFromEvent(e));
    };
    stageEl.addEventListener('pointerdown', grab);
    stageEl.addEventListener('pointermove', e => { if (dragging) setPos(posFromEvent(e)); });
    window.addEventListener('pointermove', e => { if (dragging) setPos(posFromEvent(e)); });
    window.addEventListener('pointerup', () => { dragging = false; });
    window.addEventListener('pointercancel', () => { dragging = false; });
    range.addEventListener('input', e => { touched = true; setPos(Number(e.target.value)); });

    setPos(20);

    /* One sweep the first time the pair scrolls into view. It teaches the drag
       without a tooltip, and it never runs again or fights the buyer. */
    if (calmMotion || !('IntersectionObserver' in window)) return;
    const hint = () => {
      const from = 20, to = 45, t0 = performance.now(), dur = 1500;
      stageEl.classList.add('is-hinting');
      const step = now => {
        if (touched) { stageEl.classList.remove('is-hinting'); return; }
        const k = Math.min(1, (now - t0) / dur);
        const ease = 0.5 - Math.cos(k * Math.PI * 2) / 2;      // out and back
        setPos(from + (to - from) * ease);
        if (k < 1) requestAnimationFrame(step);
        else { setPos(20); stageEl.classList.remove('is-hinting'); }
      };
      requestAnimationFrame(step);
    };
    new IntersectionObserver((entries, obs) => {
      entries.forEach(en => {
        if (!en.isIntersecting) return;
        obs.disconnect();
        setTimeout(hint, 180 * idx);   // stagger, so the six do not sweep in unison
      });
    }, { threshold: 0.45 }).observe(stageEl);
  });

  /* ---------- before / after rail ----------
     Six pairs on one line. The arrows page by whole cards, the edge fades say
     there is more, and both states come off the scroll position rather than a
     counter, so a flick, a drag on the scrollbar and an arrow all agree. */
  const baRail  = $('#vy-ba-rail');
  const baTrack = $('#vy-ba-track');
  if (baRail && baTrack) {
    const step = () => {
      const card = $('.vy-ba-card', baTrack);
      if (!card) return baTrack.clientWidth;
      const gap = parseFloat(getComputedStyle(baTrack).columnGap) || 0;
      // page by whole cards, but never further than one screen of the rail
      const per = Math.max(1, Math.floor(baTrack.clientWidth / (card.offsetWidth + gap)));
      return (card.offsetWidth + gap) * per;
    };
    const syncRail = () => {
      const max = baTrack.scrollWidth - baTrack.clientWidth;
      const x = baTrack.scrollLeft;
      const atStart = x <= 2, atEnd = x >= max - 2;
      baRail.dataset.atStart = String(atStart);
      baRail.dataset.atEnd = String(atEnd || max <= 0);
      $$('[data-ba-nav]', baRail).forEach(b => {
        b.disabled = Number(b.dataset.baNav) < 0 ? atStart : (atEnd || max <= 0);
      });
    };
    $$('[data-ba-nav]', baRail).forEach(btn => btn.addEventListener('click', () => {
      baTrack.scrollBy({ left: Number(btn.dataset.baNav) * step(), behavior: calmMotion ? 'auto' : 'smooth' });
    }));
    baTrack.addEventListener('scroll', syncRail, { passive: true });
    window.addEventListener('resize', syncRail);
    syncRail();
    // images settle after layout and change scrollWidth, so check again once loaded
    window.addEventListener('load', syncRail);
  }

  /* ---------- review tabs ---------- */
  const rTabs  = $$('.vy-rtab');
  const rPanel = $('#vy-rpanel');
  if (rTabs.length && rPanel) {
    const cards = $$('.vy-review', rPanel);

    const rRaw     = $('#vy-rraw');
    const rRawNote = $('#vy-rraw-note');
    const rNote    = $('#vy-rnote');

    function showTab(key, quiet) {
      rTabs.forEach(t => {
        const on = t.dataset.tab === key;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        if (on) rPanel.setAttribute('aria-labelledby', t.id);
      });

      // the photo tab swaps the masonry out for the image grid
      const raw = key === 'raw';
      if (rRaw)     rRaw.hidden = !raw;
      if (rRawNote) rRawNote.hidden = !raw;
      if (rNote)    rNote.hidden = raw;
      rPanel.hidden = raw;
      if (raw) return;

      if (quiet) {   // first paint: match the markup without fading anything in
        cards.forEach(c => { c.hidden = key !== 'all' && c.dataset.tags !== key; });
        return;
      }

      rPanel.classList.add('is-swapping');
      // one frame at zero opacity, then reveal the new set so the swap reads
      requestAnimationFrame(() => {
        cards.forEach(c => { c.hidden = key !== 'all' && c.dataset.tags !== key; });
        requestAnimationFrame(() => rPanel.classList.remove('is-swapping'));
      });
    }

    rTabs.forEach((tab, i) => {
      tab.addEventListener('click', () => showTab(tab.dataset.tab));
      tab.addEventListener('keydown', e => {
        const dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!dir) return;
        e.preventDefault();
        const next = rTabs[(i + dir + rTabs.length) % rTabs.length];
        next.focus();
        showTab(next.dataset.tab);
      });
    });

    /* the tab the markup marks selected owns the initial state, so the two
       cannot drift when the default tab changes */
    const first = rTabs.find(t => t.getAttribute('aria-selected') === 'true') || rTabs[0];
    showTab(first.dataset.tab, true);
  }

  /* ---------- photo lightbox ---------- */
  const lb = $('#vy-lightbox'), lbImg = $('#vy-lightbox-img');
  if (lb && lbImg) {
    let lbOpener = null;
    const closeLb = () => {
      lb.hidden = true;
      document.body.classList.remove('vy-noscroll');
      if (lbOpener) lbOpener.focus();
    };
    $$('.vy-rshot').forEach(btn => btn.addEventListener('click', () => {
      lbOpener = btn;
      lbImg.src = btn.dataset.shot;
      lbImg.alt = $('img', btn) ? $('img', btn).alt : '';
      lb.hidden = false;
      document.body.classList.add('vy-noscroll');
      $('.vy-lightbox-x', lb).focus();
    }));
    $$('[data-lbclose]', lb).forEach(el => el.addEventListener('click', closeLb));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !lb.hidden) closeLb(); });
  }

  /* ---------- card groups fly in once, each from its own side ---------- */
  ['#vy-orbit', '#vy-why', '#vy-how'].forEach(sel => {
    const group = $(sel);
    if (!group) return;
    if (calmMotion || !('IntersectionObserver' in window)) { group.classList.add('is-in'); return; }
    new IntersectionObserver((entries, obs) => {
      entries.forEach(en => {
        if (!en.isIntersecting) return;
        group.classList.add('is-in');
        obs.disconnect();
      });
    }, { threshold: 0.25 }).observe(group);
  });

  /* ---------- product pieces tilt toward the cursor ---------- */
  const finePointer = window.matchMedia && window.matchMedia('(hover:hover)').matches;
  function trackTilt(rigSel, hostSel, max) {
    const rig = $(rigSel), host = $(hostSel);
    if (!rig || !host || calmMotion || !finePointer) return;
    let raf = 0;
    host.addEventListener('pointermove', e => {
      const r = host.getBoundingClientRect();
      const tx = ((e.clientX - r.left) / r.width  - 0.5) * 2;   // -1 .. 1
      const ty = ((e.clientY - r.top)  / r.height - 0.5) * 2;
      rig.classList.add('is-tracking');
      if (!raf) raf = requestAnimationFrame(() => {
        raf = 0;
        rig.style.setProperty('--ry', (tx * max).toFixed(2) + 'deg');
        rig.style.setProperty('--rx', (-ty * max * 0.55).toFixed(2) + 'deg');
      });
    });
    host.addEventListener('pointerleave', () => {
      rig.classList.remove('is-tracking');            // longer easing on the way home
      rig.style.setProperty('--ry', '0deg');
      rig.style.setProperty('--rx', '0deg');
    });
  }
  trackTilt('#vy-orbit-3d', '.vy-orbit-sec', 11);
  trackTilt('#vy-why-3d', '#vy-why', 9);

  /* ---------- footer signup (prototype: no backend) ---------- */
  const footForm = $('#vy-foot-form');
  if (footForm) {
    footForm.addEventListener('submit', e => {
      e.preventDefault();
      const email = $('#vy-foot-email');
      if (!email.value || !email.checkValidity()) return;
      footForm.classList.add('is-done');
      email.value = '';
      email.placeholder = 'Thank you, you are on the list';
      email.disabled = true;
      const note = $('#vy-foot-formnote');
      if (note) note.textContent = 'Check your inbox for the week-one photo guide. One email a month from here.';
    });
  }

  /* ---------- survey stat bar ----------
     One claim at a time, the ring redraws to each figure. Pauses on hover so a
     line can be read, and holds still entirely under reduced motion. */
  const statbar = $('#vy-statbar');
  if (statbar) {
    const lines = $$('.vy-statbar-lines li', statbar);
    const arc   = $('#vy-statbar-arc');
    const pct   = $('#vy-statbar-pct');
    const dots  = $('#vy-statbar-dots');
    const CIRC  = 91.1;                       // 2 * pi * r, r = 14.5
    let at = 0, timer = null;

    lines.forEach((_, i) => {
      const b = document.createElement('b');
      if (i === 0) b.className = 'is-on';
      dots.appendChild(b);
    });
    const marks = $$('b', dots);

    function show(i) {
      at = (i + lines.length) % lines.length;
      const n = Number(lines[at].dataset.pct);
      lines.forEach((li, k) => li.classList.toggle('is-on', k === at));
      marks.forEach((b, k) => b.classList.toggle('is-on', k === at));
      pct.textContent = n + '%';
      arc.style.strokeDashoffset = String(CIRC * (1 - n / 100));
    }
    const stop = () => { clearInterval(timer); timer = null; };
    const play = () => { if (!timer && !calmMotion) timer = setInterval(() => show(at + 1), 4200); };

    show(0);
    statbar.addEventListener('pointerenter', stop);
    statbar.addEventListener('pointerleave', play);

    // only run while the bar is actually on screen
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => (e.isIntersecting ? play() : stop()), { threshold: 0 }).observe(statbar);
    } else {
      play();
    }
  }

  /* ---------- sticky ATC + header banner ----------
     On once the buybox has scrolled past, off again the moment the footer
     arrives. The footer is the end of the pitch: she is reading contact details
     and policy links there, and two bars hanging over that is nagging, not
     selling. The two conditions are tracked separately and combined here,
     because one observer cannot watch two elements independently. */
  const sticky = $('#vy-sticky');
  const topbar = $('#vy-topbar');
  const buybox = $('#vy-buybox');
  const foot   = $('.vy-foot');

  let pastBuybox = false, atFooter = false;
  const syncBars = () => {
    const on = pastBuybox && !atFooter;
    if (sticky) sticky.classList.toggle('is-on', on);
    if (topbar) {
      topbar.classList.toggle('is-on', on);
      topbar.setAttribute('aria-hidden', String(!on));
    }
  };

  if (buybox && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      pastBuybox = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      syncBars();
    }, { threshold: 0 }).observe(buybox);

    if (foot) {
      new IntersectionObserver(([entry]) => {
        atFooter = entry.isIntersecting;
        syncBars();
      }, { threshold: 0 }).observe(foot);
    }
  }

  /* ---------- init ---------- */
  pickZone(state.zone);
  pickTier(state.tier);

  /* the Vitals currency layer lands seconds after first paint; every price
     on the page is drawn inside render(), so one re-render speaks it */
  document.addEventListener('vy:currency', render);
})();
